import React from "react";
import {observer} from "mobx-react-lite";
import './SupplierNormalization.scss';
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import {useStores} from "../../stores";
import {SupplierNormalizationState} from "./pages/SupplierNormalization.classes";

export const SupplierNormalizationStepper: React.FC = observer(() => {
    const {supplierNormalizationStore} = useStores();
    const state = supplierNormalizationStore.state;
    return <Stepper orientation={"horizontal"} activeStep={supplierNormalizationStore.stepNumber}
                    className="supplier-normalization-stepper">
        <Step
            onClick={() => supplierNormalizationStore.goToState(SupplierNormalizationState.START)}>
            <StepLabel>
                {state === SupplierNormalizationState.RUNNING ? 'Running ...' : 'Start model'}
            </StepLabel>
        </Step>
        <Step
            onClick={() => supplierNormalizationStore.goToState(SupplierNormalizationState.REVIEW)}>
            <StepLabel>
                Normalization
            </StepLabel>
        </Step>
        <Step
            onClick={() => supplierNormalizationStore.goToState(SupplierNormalizationState.APPLYING)}>
            <StepLabel>
                Review
            </StepLabel>
        </Step>
    </Stepper>
});
